// src/app/store/sensor-type/sensor-type.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import { SensorActions } from './sensor-actions';
import { initialSensorState, SensorState } from './sensor-state';

const _sensorTypeReducer = createReducer(
  initialSensorState,
  on(SensorActions.loadSensorTypes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SensorActions.loadSensorTypesSuccess, (state, { sensorTypes }) => ({
    ...state,
    sensorTypes: sensorTypes, // Type is inferred from the action
    loading: false,
  })),
  on(SensorActions.loadSensorTypesFailure, (state, { error }) => ({
    ...state,
    error: error,
    loading: false,
  })),
);

export function sensorTypeReducer(state: SensorState | undefined, action: Action) {
  return _sensorTypeReducer(state, action);
}
